// extracted by mini-css-extract-plugin
export var button = "_dm-4";
export var hasDarkBackground = "_dm-7";
export var hasLightBackground = "_dm-6";
export var iconWrapper = "_dm-0";
export var large = "_dm-2";
export var medium = "_dm-1";
export var small = "_dm-5";
export var xsmall = "_dm-3";